// survey.service — submit survei (validasi No.HP terdaftar + rating) + notif.
import { wa62 } from '@domain/format';
import { pushNotif } from '@core/notif';
import * as repo from './survey.repo';

/** Submit survei: token identifikasi tiket, phone WAJIB cocok No.HP pelanggan terdaftar (anti CS scan sendiri). */
export async function submitSurvey(token: string, phone: string, rating: number, ket: string): Promise<{ rating: number; gmapsEligible: boolean }> {
  if (rating < 1 || rating > 5) throw new Error('Rating harus 1–5.');
  const t = await repo.findByToken(token);
  if (!t) throw new Error('Tautan survei tidak valid.');
  if (t.surveyDone) throw new Error('Survei untuk servis ini sudah diisi. Terima kasih!');
  if (wa62(phone) !== wa62(t.custWa)) throw new Error('No. HP tidak cocok dengan data pelanggan servis ini.');
  await repo.submit(t.no, rating, ket);
  await pushNotif('CS', t.outlet, `⭐ Survei ${t.no}: rating ${rating}/5${ket ? ' — ' + ket : ''}`, t.no);
  if (t.teknisi) await pushNotif('TEK:' + t.teknisi, t.outlet, `⭐ Survei ${t.no}: rating ${rating}/5`, t.no);
  return { rating, gmapsEligible: rating >= 4 };
}
